import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import image from "../../../assets/kangaroo/AustraliaBanner.jpg"
import "../general.css"
import { useParams } from 'react-router-dom';
import generalService from '../../../services/generalPage';
import { useQuery } from '@tanstack/react-query';
import { imageBaseApi } from '../../../services/imageBaseApi';

export default function GeneralPage() {
  const { page } = useParams();
  console.log("🚀 ~ GeneralPage ~ page:", page)


  const fetchData = async (slug) => {
    const response = await generalService.getBySlug(slug);
    return response
  }

  const { isPending, error, data: generalData } = useQuery({
    queryKey: ["generalData", page],
    queryFn: () => fetchData(page),
  })


  return (
    <Container fluid className="p-0">
      <Row className="g-0">
        <Col xs={12}>
          <div
            style={{
              width: "100%",
              height: "335px",
              overflow: "hidden",
            }}
          >
            <img
              src={imageBaseApi + generalData?.featuredMedia?.url}
              alt="Banner"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        </Col>

      </Row>



      <Container className="my-5">
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8}>
            <div className="text-start mb-4">
              <h1 className="font-level-4 mb-3">
                {generalData?.title}
              </h1>
              <p className="lead text-muted">
                {generalData?.subtitle}
              </p>
            </div>


            <div className="mt-4">
              <p className="fs-5 country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: generalData?.content || "",
                }}>

              </p>


            </div>

          </Col>
        </Row>
      </Container>
    </Container>
  );
}